// extracted by mini-css-extract-plugin
module.exports = {"root":"DlpListings_root___likz","pageStats":"DlpListings_pageStats__Iomyp","heading":"DlpListings_heading__MWeDz"};